// extracted by mini-css-extract-plugin
export default {"groupName":"RegionEventGroup_groupName__i37G-"};